export const steps = [
  {
    label: "Transparency at Every Step",
    description:
      "From the first consultation to the final visa approval, we ensure that every step of the process is clear and straightforward. You’ll always know where you stand and what’s next.",
  },
  {
    label: "Personalized Solutions",
    description:
      "Integrity is the cornerstone of our services. We uphold the highest ethical standards, providing honest advice and practical solutions tailored to your unique needs.",
  },
  {
    label: "Professional Expertise",
    description:
      "With a team of experienced consultants and in-depth knowledge of global immigration policies, we deliver reliable and accurate guidance to help you achieve your goals efficiently.",
  },
  {
    label: "Dedicated Support",
    description:
      "We’re with you every step of the way, offering pre-departure and post-landing assistance for a seamless transition.",
  },
];
